import * as z from "zod"

export const AccountTenantAccessModel = z.object({
  id: z.number().int(),
  created_at: z.date(),
  updated_at: z.date(),
  /**
   * [TenantId]
   */
  tenant_id: z.string(),
  can_edit: z.boolean(),
  account_id: z.number().int(),
})
